<script>
  import { site } from '../store.js'
</script>

<div class="hero-grid" style="background: #1e334f url(/img/lax-control-tower.jpg) no-repeat 50% 50% / cover;">
	<div class="inner">			
 		<h2>CONTACT US</h2>			
 	</div>
</div>

<div class="inner clear" id="maincontent">
	<div class="results-wrap" style="background-color: white;">
		<div class="results">						
			<div role="form" class="form" id="wpcf7-f203-p21-o1" lang="en-US" dir="ltr">
        <div class="screen-reader-response"></div>
        <form action="/contact" method="post" class="wpcf7-form">
          <p class=""><label for="contact-name" >First Name*</label><span class="wpcf7-form-control-wrap f-name"><input type="text" name="first_name" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" id="contact-name" aria-required="true" aria-invalid="false"></span> </p>
          <p class="">
            <label for="contact-last-name">Last Name</label><input type="text" name="last_name" value="" size="40" class="wpcf7-form-control wpcf7-text" id="contact-last-name" aria-invalid="false"></p>
          <p class=""><label for="contact-title">Title</label><input type="text" name="title" value="" size="40" class="wpcf7-form-control wpcf7-text" id="contact-title" aria-invalid="false"></p>
          <p class=""><label for="contact-email">Email*</label><input type="email" name="email" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email" id="contact-email" ></p>
          <p class=""><label for="contact-phone">Phone*</label><input type="tel" name="phone" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel" id="contact-phone" ></p>
          <p class="">
            <label for="contact-reason">Who to Contact</label>
            <select name="target" class="form-control wpcf7-select" id="contact-reason" aria-invalid="false" style="">
              {#each $site.company.list as co}
                <option value={ co.name }>{ co.name }</option>
              {/each}
            </select>
          </p>
          <div>
            <p class="">
              <label for="contact-message">Message</label>
              <textarea name="message" cols="40" rows="10" maxlength="1000" class="wpcf7-form-control wpcf7-textarea" id="contact-message" aria-invalid="false" required></textarea>
            </p>
            <p class="submit-box">
              <button type="submit">Submit</button>
            </p>
          </div>
        </form>
      </div>
    </div>			
  </div>

  <div class="col-33 story-col">
    {#each $site.company.list  as co }				
      <div class="contact-item">															
        <h3>{ co.name }</h3>
        <p>
          { co.address.street }<br>
          { co.address.city } { co.address.state } { co.address.postal_code }<br>
          { co.address.country }<br>
          {#if co.map_url }
            <a href="{ co.map_url }">Map</a><br>
          {/if}
          <strong>Telephone: <a href="tel:{ co.phone }">{ co.phone }</a></strong><br>
          <a href="mailto:{ co.email }">{ co.email }</a>
        </p>
        {#if co.code }
          <p>For job status or records, please visit:<br>
          <a href="https://www.theaero.com/status/hub/{ co.code }" style="text-decoration: none;"><i class="fas fa-paper-plane"></i> Customer Portal</a></p>
        {/if}
      </div>	
    {/each}
  </div>	
</div>	


<style>
  form{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 40px;
  }
  form > p{
    padding-bottom: 10px;
    flex: 0 0 48%;
  }
  form > div{
    flex: 1 1 100%;
  }
  select{
    border: 2px solid #e9e9e9;
    border-radius: 0;
    height: 58px;
    font-size: 1.6rem;
    font-family: 'Avenir', Arial, sans-serif;
  }

</style>
